import React from 'react';
import Button from '../ui/Button';
import { MessageCircleIcon, StarIcon } from 'lucide-react';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
const FinalCTA = () => {
  const {
    t,
    language
  } = useLanguage();
  return <section className="py-20 px-4 bg-primary text-white relative overflow-hidden" data-id="element-141">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-142"></div>
      <div className="absolute -top-24 -right-24 w-64 h-64 bg-accent rounded-full blur-3xl opacity-20" data-id="element-143"></div>
      <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-success rounded-full blur-3xl opacity-20" data-id="element-144"></div>

      <div className="container mx-auto max-w-4xl relative z-10 text-center" data-id="element-145">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-2 rounded-full border border-white/20 mb-8" data-id="element-146">
          <div className="flex" data-id="element-147">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#FFD700] fill-[#FFD700]" data-id="element-148" />)}
          </div>
          <span className="text-sm font-medium text-gray-200" data-id="element-149">
            {t.finalCta.badge}
          </span>
        </div>

        <h2 className="font-heading font-extrabold text-4xl md:text-6xl mb-6 leading-tight" data-id="element-150">
          <span className="text-accent block text-2xl md:text-3xl mb-2 uppercase tracking-widest opacity-90" data-id="element-151">
            {t.finalCta.headlineAccent}
          </span>
          {t.finalCta.headline}
        </h2>

        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-152">
          {t.finalCta.subheadline}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-153">
          <Button href="#lead-form" variant="success" size="lg" className="shadow-[0_4px_24px_rgba(37,211,102,0.35)] hover:shadow-[0_6px_32px_rgba(37,211,102,0.5)] hover:scale-[1.03] text-lg px-10 py-4 font-bold" onClick={() => trackContact({
          location: 'final_cta',
          language,
          action: 'scroll_to_form'
        })} data-id="element-154">
            <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-155" />
            {t.finalCta.cta}
          </Button>
        </div>

        <p className="mt-6 text-sm text-gray-400" data-id="element-156">{t.finalCta.footer}</p>
      </div>
    </section>;
};
export default FinalCTA;